export default __webpack_public_path__ + "static/4-09dcf83c698ac9e747cb7f8291c520f1.jpeg";